module.exports = __webpack_public_path__ + "static/media/ArrowRightWhite.8a47a0bf.svg";